<script lang="ts">
export default {
  name: 'ExportButton',
};
</script>

<script setup lang="ts">
import { StoreMutationType } from '@/types/StoreMutationType';
import { Download } from '@lucide/vue';
import { computed } from 'vue';
import { useStore } from 'vuex';
import { AppState } from '@/store';

// ---------------
// reactive data
// ---------------
const store = useStore<AppState>();

// ----------
// computed
// ----------
const exportListShowing = computed<boolean | undefined>(() => {
  return store?.state.towerVisualizerState.showExportOptions;
});

// ----------
// handlers
// ----------
function toggleExportOptions(e: MouseEvent): void {
  e.stopPropagation();
  store?.commit(StoreMutationType.SHOW_VISUALIZER_EXPORT_OPTIONS, !store?.state.towerVisualizerState.showExportOptions);
}
</script>

<template>
  <div class="py-2 pr-2 pl-1 self-end">
    <label title="Export">
      <input
        type="checkbox"
        name="export-button"
        aria-label="Export Button"
        class="box-border pointer-events-none hidden"
        @click="toggleExportOptions"
      /> <slot name="icon" :export-list-showing="exportListShowing">
      <div
          :class="{ selected: exportListShowing }"
          class="bg-base-200 border border-solid border-gray-300 hover:bg-gray-300 transition-all flex items-center justify-center cursor-pointer pointer-events-auto border-box rounded-lg shadow-lg w-10 h-10"
        >
          <Download :size="18" />
        </div>
      </slot>
    </label>
  </div>
</template>

<style scoped>
.toggle-button {
  background-color: var(--tower-v2-alt-bg-color);
  border: 1px solid var(--tower-v2-border-color);
}

.selected {
  background-color: var(--tower-v2-tool-selected-color);
}
</style>
